import PropTypes from "prop-types"
import classnames from "classnames"
import { DATE } from "helpers/shapes"
import { formatLongDate } from "helpers/formatters/dates"
import { getSortOrderUpdates } from "helpers/compositeSecurities"
import DailyDetails from "./components/daily-details"
import Contributors from "modules/analyze-composite-performance-contributors"
import "./style.scss"

function AnalyzeCompositePerformanceDetails({
  modelId,
  positionSetId,
  positionSetType,
  positionSetName,
  classifications,
  mustAggregateFactors,
  segment,
  base,
  baseSignature,
  selectedDate,
  performanceFetchStartDate,
  selectedContributorCategory,
  selectedContributorValue,
  viewType,
  selectedOption,
  details,
  expand,
  sortOrder,
  openSecurityProfile,
  openFactorProfile,
  showGroup,
  hideGroup,
  currentGrouping,
  setGrouping,
  selectedGroup,
  groupOrder,
  showNotHeld,
  selectedViews,
  setSortOrder,
  setGroupSortOrder,
  showContributorCategory,
  hideContributorCategory,
  factorsClassification,
}) {
  const handleSort = ({ by, current }) => {
    setSortOrder({
      ...current,
      ...getSortOrderUpdates({ by, current }),
    })
  }

  return <div className={classnames("modules_analyze-composite-performance-details")}>
    <h4 className="header">As of {formatLongDate(selectedDate)}</h4>
    {!selectedContributorCategory
      ? <DailyDetails {...{
          viewType,
          openFactorProfile,
          data: details,
          factorTable: selectedOption.id !== "total" && selectedOption.id !== "factors",
          show: showContributorCategory,
          groupSort: (order) => setGroupSortOrder({ ...groupOrder, order }),
          groupOrder,
        }}
      />
      : <Contributors {...{
          modelId,
          positionSetId,
          positionSetType,
          positionSetName,
          classifications,
          segment,
          mustAggregateFactors,
          selectedDate,
          performanceFetchStartDate,
          viewType,
          expand,
          openSecurityProfile,
          openFactorProfile,
          showContributorCategory,
          hideContributorCategory,
          sort: handleSort,
          sortOrder,
          selectedContributorCategory,
          selectedContributorValue,
          selectedGroup,
          showGroup,
          hideGroup,
          currentGrouping,
          setGrouping,
          selectedOption,
          details,
          groupOrder,
          selectedViews,
          showNotHeld,
          base,
          baseSignature,
          factorsClassification,
        }}
      />}
  </div>
}

AnalyzeCompositePerformanceDetails.propTypes = {
  modelId: PropTypes.string.isRequired,
  positionSetId: PropTypes.string.isRequired,
  positionSetType: PropTypes.string.isRequired,
  positionSetName: PropTypes.string.isRequired,
  classifications: PropTypes.array,
  segment: PropTypes.object,
  mustAggregateFactors: PropTypes.bool.isRequired,
  selectedDate: DATE.isRequired,
  showContributorCategory: PropTypes.func.isRequired,
  hideContributorCategory: PropTypes.func.isRequired,
  performanceFetchStartDate: DATE.isRequired,
  performanceHistory: PropTypes.array.isRequired,
  selectedContributorCategory: PropTypes.object,
  selectedContributorValue: PropTypes.number.isRequired,
  allCategoryItems: PropTypes.array.isRequired,
  details: PropTypes.array.isRequired,
  viewType: PropTypes.string.isRequired,
  expand: PropTypes.bool.isRequired,
  selectedOption: PropTypes.object.isRequired,
  sortOrder: PropTypes.object.isRequired,
  setSortOrder: PropTypes.func.isRequired,
  openSecurityProfile: PropTypes.func.isRequired,
  openFactorProfile: PropTypes.func.isRequired,
  currentGrouping: PropTypes.object,
  setGrouping: PropTypes.func.isRequired,
  selectedGroup: PropTypes.object,
  showGroup: PropTypes.func.isRequired,
  hideGroup: PropTypes.func.isRequired,
  filtersVisible: PropTypes.bool.isRequired,
  setGroupSortOrder: PropTypes.func.isRequired,
  groupOrder: PropTypes.object.isRequired,
  showNotHeld: PropTypes.bool.isRequired,
  selectedViews: PropTypes.array,
  base: PropTypes.object,
  baseSignature: PropTypes.string,
  factorsClassification: PropTypes.object,
}

export default AnalyzeCompositePerformanceDetails
